import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  SET_ACCESS_TOKEN,
  RESTE_ALL_AUTH_DATA,
  SET_PROFILE_AUTH
} from "../../redux/action/auth/type";
import { SET_SERVERTIME_INFO } from "../../redux/action/info/type";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCookies } from "react-cookie";

const AuthContent = () => {
  
    const dispatch = useDispatch();
    const profile = useSelector((state) => state.auth.profile);
    const accessToken = useSelector((state) => state.auth.accessToken);
    
    const [loading, setLoading] = useState(true);
    
    const [cookies, setCookies] = useCookies()
    
    const navigate = useNavigate();

    // گرفتن پروفایل
    const fetchProfile = async (token) => {
        try {
            const res = await axios.get(
                "https://my-sarad-back.liara.run/api/user/profile",
                { headers: { Authorization: `Bearer ${token}` } }
            );

            dispatch({
                type: SET_PROFILE_AUTH,
                payload: res.data?.user
            });

            if(res.data?.dateNowServer){
            
                dispatch({
                    type: SET_SERVERTIME_INFO,
                    payload: res.data?.dateNowServer
                })
                
            }

            return res.data?.user;

        } catch (err) {
        return null;
        }
    };

    // گرفتن access token جدید
    const refreshAccess = async () => {
        try {
            const res = await axios.post(
                "https://my-sarad-back.liara.run/api/auth/refresh-token",
                {refreshToken: cookies?.refreshToken}
            );

            const newAccess = res.data?.accessToken;

            dispatch({
                type: SET_ACCESS_TOKEN,
                payload: newAccess
            });

            return newAccess;

        } catch (err) {
         return null;
        }
    };

    useEffect(() => {

        document.querySelector('body').classList.add('bg-second')
       
        const checkAuthForAuthPage = async () => {

            // اگر قبلاً پروفایل داریم → نباید صفحه Auth را ببیند
            if (profile && Object.keys(profile).length > 0) {
                navigate("/");
                return;
            }

            let token = accessToken;

            // اول حالت → اگر accessToken نداریم → امتحان refresh
            if (!token) {
                token = await refreshAccess();
            }

            // اگر توکنی به دست نیامد → کاربر لاگین نیست → همین صفحه بماند
            if (!token) {
                setLoading(false);
                return;
            }

            // حالا تلاش کن پروفایل بگیری
            let prof = await fetchProfile(token);

            // اگر access token باطل شده بود
            if (!prof) {

                const newToken = await refreshAccess();

                if (!newToken) {
                    dispatch({ type: RESTE_ALL_AUTH_DATA });
                    setLoading(false);
                    return;
                }

                prof = await fetchProfile(newToken);

                if (!prof) {
                    dispatch({ type: RESTE_ALL_AUTH_DATA });
                    setLoading(false);
                    return;
                }
            }

            // اگر پروفایل گرفت → نباید صفحه Auth ببیند
            navigate("/");

        };

        checkAuthForAuthPage();

        return () => {
            document.querySelector('body').classList.remove('bg-second')
            
            // پاک کردن شماره‌ای ک موقت نگهرداشتیم برای اینکه اگر شماره وارد میکنه موقع ورود و شمارش نیست بره ثبت نام و درجا شماره هم بخونه اینو ساخته بودیم
            localStorage.removeItem('convertMobile')
        }

    }, []);


    if (loading) 
        return (
            <div className="flex min-h-[90vh] items-center justify-center">

                در حال بررسی وضعیت ورود...

            </div>
        )

    return (
       <>
            
            <main className="flex items-center px-3 py-3 justify-center min-h-[90vh]">

                <Outlet />
            
            </main>

            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                rtl
            />

       </>
    )

};

export default AuthContent;